import { DesignerToolArrangeObserverEntry } from "./designer-tool-arrange-observer-entry";

export abstract class DesignerToolArrangeObserver {
  private static entries = new Map<
    HTMLElement,
    DesignerToolArrangeObserverEntry
  >();

  public static observe(el: HTMLElement) {
    if (!this.entries.has(el)) {
      this.entries.set(el, new DesignerToolArrangeObserverEntry(el));
    }
  }

  public static unobserve(el: HTMLElement) {
    if (this.entries.has(el)) {
      this.entries.get(el).destroy();
      this.entries.delete(el);
    }
  }
}
